// src/modules/wiring/hooks/useFloorTransitionContinue.js
//
// Kat-geçiş devam: hedef kattaki "gelen ok" (incomingFloorTransitionArrow) işaretçisine
// tıklayınca, kaynak hattın komutunu (sourceCommandType) aktive edip o noktadan otomatik
// hat çizimini başlatır (useWireAutoSelectBuat devreye girer). Kullanıcı kat geçişinin
// devamını buradan çizer.
//
// Standalone hook (useFixtureDraggableText deseni): CAPTURE faz mousedown +
// stopImmediatePropagation ile selection/gizmo'dan önce "claim" eder.

import { useEffect } from 'react';
import * as THREE from 'three';
import { useDispatch } from 'react-redux';
import { setCommandType, setOperationData } from '../../../redux/operationSlice';

export default function useFloorTransitionContinue(scene, camera, renderer) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!scene || !camera || !renderer) return;
    const dom = renderer.domElement;

    const onDown = (e) => {
      if (e.button !== 0) return;
      const r = dom.getBoundingClientRect();
      const ndc = new THREE.Vector2(
        ((e.clientX - r.left) / r.width) * 2 - 1,
        -((e.clientY - r.top) / r.height) * 2 + 1
      );
      const rc = new THREE.Raycaster();
      rc.setFromCamera(ndc, camera);
      const hits = rc.intersectObjects(scene.children, true);
      for (const h of hits) {
        if (h.object.visible === false) continue;
        // İşaretçiye (incomingFloorTransitionArrow) kadar yukarı çık
        let n = h.object;
        while (n && n.userData?.type !== 'incomingFloorTransitionArrow') n = n.parent;
        if (!n) continue;
        const cmd = n.userData?.sourceCommandType;
        if (!cmd) return; // komut bilinmiyor → devam edilemez (selection'a bırak)

        // CLAIM: selection/gizmo bu tıklamayı işlemesin
        e.stopImmediatePropagation();
        e.preventDefault();

        const wp = new THREE.Vector3();
        n.getWorldPosition(wp);

        // Komutu aktive et + o noktadan otomatik çizim başlat (useWireAutoSelectBuat)
        dispatch(setCommandType(cmd));
        dispatch(setOperationData({
          commandType: cmd,
          autoSelectBuat: { position: { x: wp.x, y: wp.y, z: wp.z } },
          source: {
            type: 'floorTransitionContinue',
            position: { x: wp.x, y: wp.y, z: wp.z },
            sourceWireId: n.userData?.sourceWireId || null,
            sourceFloorPlanId: n.userData?.sourceFloorPlanId || null,
            incomingArrowId: n.userData?.id || null,
          },
        }));
        return;
      }
    };

    dom.addEventListener('mousedown', onDown, true); // capture
    return () => dom.removeEventListener('mousedown', onDown, true);
  }, [scene, camera, renderer, dispatch]);
}
